import { useQuery } from 'react-query';
import { InputOrder } from 'features/dashboard/ts/InputOrder';
import { getSingleOrderSummary } from 'features/dashboard/api';

export const useSingleOrderSummaryQuery = (data: InputOrder, queryKeys: unknown[]) => {
  const result = useQuery(
    [`single-order-summary`, ...queryKeys],
    async () => {
      const { data: response } = await getSingleOrderSummary(data);
      return response;
    },
    { staleTime: Infinity, retry: false, keepPreviousData: false }
  );

  return result;
};
